<template>
  <div class="nav">
    <a-typography-title :level="4">配置</a-typography-title>
    <a-space>
      <a-button @click="shardCk">碎片</a-button>
      <a-button type="dashed" @click="exCk">兑换</a-button>
      <a-button @click="chanceCk">时段修正</a-button>
      <a-button type="dashed" @click="chanceViewCk">演算</a-button>
      <a-select class="long-select"
                :options="configList"
                v-model:value="k"
                show-search
                @change="query"/>
      <a-button type="primary" @click="addCk">添加</a-button>
    </a-space>
  </div>

  <a-table size="small"
           :columns="columns"
           :data-source="source"
           :pagination="false"
           :loading="loading">
    <template v-slot:bodyCell="{ column, record }">
      <template v-if="column.dataIndex === 'v'">
        <div class="wb">{{ record.v }}</div>
      </template>

      <template v-else-if="column.dataIndex === 'act'">
        <a-space>
          <template v-if="k === 'act_anniversary_daily' || k === 'act_anniversary_grand'">
            <a-button @click="drawCk(record)" size="small">抽奖</a-button>
            <a-button @click="pubCk(record)" size="small">开奖</a-button>
          </template>
          <a-button @click="updCk(record)" size="small">编辑</a-button>
          <a-button danger @click="delCk(record)" size="small">删除</a-button>
        </a-space>
      </template>

      <template v-else>
        {{ record[column.dataIndex] }}
      </template>
    </template>
  </a-table>

  <add-modal ref="add" @refresh="query"/>

  <upd-modal ref="upd" @refresh="query"/>

  <shard-modal ref="shard"/>

  <ex-modal ref="ex"/>

  <chance-modal ref="chance"/>

  <analyze-modal ref="analyze"/>
</template>

<script setup>
import {ref} from 'vue'
import {message, Modal} from 'ant-design-vue'
import axios from '@/axios'

import AddModal from '@/views/config/Add.vue'
import UpdModal from '@/views/config/Upd.vue'
import ShardModal from '@/views/config/Shard.vue'
import ExModal from '@/views/config/ExRes.vue'
import ChanceModal from '@/views/config/Chance.vue'
import AnalyzeModal from '@/views/config/Analyze.vue'

const add = ref(null)
const upd = ref(null)
const shard = ref(null)
const ex = ref(null)
const chance = ref(null)
const analyze = ref(null)

const loading = ref(false)
const k = ref('')

const source = ref([])
const configList = ref([])

const columns = [
  {
    key: 'id',
    title: 'ID',
    dataIndex: 'id',
  }, {
    key: 'k',
    title: '键',
    dataIndex: 'k',
  }, {
    key: 'v',
    title: '值',
    dataIndex: 'v',
  }, {
    key: 'act',
    title: '操作',
    dataIndex: 'act',
  }
]

function query() {
  loading.value = true

  axios.get('/config', {
    params: {
      k: k.value
    }
  }).then((res) => {
    loading.value = false
    if (res.code === 1) {
      source.value = res.data
    }
  })
}

function option() {
  axios.get('/config-opt').then((res) => {
    if (res.code === 1) {
      configList.value = res.data
      if (configList.value.length) {
        k.value = configList.value[0].value
      }
      query()
    }
  })
}

function addCk() {
  add.value.openCk(k.value)
}

function shardCk() {
  shard.value.openCk()
}

function exCk() {
  ex.value.openCk()
}

function chanceCk() {
  chance.value.openCk()
}

function chanceViewCk() {
  analyze.value.openCk()
}

function updCk(record) {
  upd.value.openCk(record)
}

function delCk(record) {
  Modal.confirm({
    content: '确定删除吗？',
    okText: '删除',
    okType: 'danger',
    cancelText: '取消',
    onOk() {
      axios.delete(`/config/${record.id}`).then((res) => {
        if (res.code === 1) {
          message.success('操作成功')
          query()
        }
      })
    },
  })
}

function drawCk(record) {
  Modal.confirm({
    content: '开始抽奖',
    okText: '确定',
    cancelText: '取消',
    onOk() {
      axios.post('/act-anniversary', {
        id: record.id
      }).then((res) => {
        if (res.code === 1) {
          message.success('操作成功')
          query()
        }
      })
    },
  })
}

function pubCk(record) {
  Modal.confirm({
    content: '发布结果',
    okText: '确定',
    cancelText: '取消',
    onOk() {
      axios.post('/act-anniversary-pub', {
        id: record.id
      }).then((res) => {
        if (res.code === 1) {
          message.success('操作成功')
          query()
        }
      })
    },
  })
}

option()
</script>

<style scoped>
.long-select {
  width: 200px;
}

.wb {
  word-break: break-all;
}
</style>